import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useParams } from "react-router-dom";

export const useFetchSeasonsByTaskStatus = ({
  taskStatus,
  page,
  pageSize,
}: {
  taskStatus: string;
  page: number;
  pageSize: number;
}) => {
  const callApi = useApi();
  const { sport, organizationId } = useParams();

  return useQuery({
    queryKey: ["seasons", sport, organizationId, taskStatus, page],
    queryFn: () =>
      callApi(
        `/${sport}/o/${organizationId}/seasons?taskStatus=${taskStatus}&limit=${pageSize}&offset=${pageSize * page - pageSize}`,
        {
          defaultErrorMessage: "Can't fetch seasons by task status",
        }
      ),
    placeholderData: (prev) => prev,
  });
};

export const useFetchFixtureSeasonsByTaskStatus = ({ taskStatus }: { taskStatus: string }) => {
  const callApi = useApi();
  const { sport, organizationId } = useParams();

  return useQuery({
    queryKey: ["seasons", "fixtures", sport, organizationId, taskStatus],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/fixtures/seasons?taskStatus=${taskStatus}`, {
        defaultErrorMessage: "Can't fetch fixture seasons by task status",
      }),
  });
};

export const useFetchSeasonsByEntityId = ({ entityId, enabled }: { entityId: string; enabled?: boolean }) => {
  const { sport, organizationId } = useParams();
  const callApi = useApi();

  return useQuery({
    queryKey: ["seasons", sport, organizationId, entityId],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/entities/${entityId}/seasons`, {
        defaultErrorMessage: "Can't fetch seasons by entity",
      }),
    enabled: enabled,
  });
};

export const useFetchSeason = ({ entityId, seasonId }: { entityId: string; seasonId: string }) => {
  const { sport, organizationId } = useParams();
  const callApi = useApi();

  return useQuery({
    queryKey: ["season", sport, organizationId, entityId, seasonId],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/entities/${entityId}/seasons/${seasonId}`, {
        defaultErrorMessage: "Can't fetch season",
      }),
  });
};
